import * as React from 'react';

const CustomerCareWidgetIllustration = React.memo((): React.ReactElement => {
  return (
    <svg
      width="104"
      height="82"
      viewBox="0 0 104 82"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
      data-testid="customer-care-widget-illustration"
    >
      <path
        d="M84.966 78.707H17.685c-.897 0-1.58-.735-1.524-1.63L18.93 33c.057-.898.837-1.63 1.73-1.63h67.282c.896 0 1.58.735 1.523 1.63l-2.77 44.077c-.057.898-.837 1.63-1.73 1.63z"
        fill="#263238"
      />
      <path
        opacity=".6"
        d="M84.966 78.707H17.685c-.897 0-1.58-.735-1.524-1.63L18.93 33c.057-.898.837-1.63 1.73-1.63h67.282c.896 0 1.58.735 1.523 1.63l-2.77 44.077c-.057.898-.837 1.63-1.73 1.63z"
        fill="#000"
      />
      <path
        d="M84.463 78.707H17.18c-.896 0-1.58-.735-1.524-1.63L18.428 33c.057-.898.837-1.63 1.73-1.63h67.281c.897 0 1.58.735 1.524 1.63l-2.771 44.077c-.057.898-.836 1.63-1.73 1.63zM84.378 79.26H4.318c-.772 0-1.446.451-1.754 1.101a.563.563 0 00.514.803H85.62c.419 0 .691-.43.514-.803a1.948 1.948 0 00-1.754-1.101h-.003z"
        fill="#263238"
      />
      <path
        opacity=".6"
        d="M84.378 79.26H72.992c-.772 0-1.446.451-1.754 1.101a.563.563 0 00.514.803h13.87c.418 0 .69-.43.513-.803a1.949 1.949 0 00-1.754-1.101h-.003z"
        fill="#000"
      />
      <path
        d="M77.319 80.652H74.38a.26.26 0 01-.258-.259.26.26 0 01.258-.26h2.938a.26.26 0 01.258.26.26.26 0 01-.258.26z"
        fill="#407BFF"
      />
      <path
        opacity=".7"
        d="M39.498 80.652h-2.937a.26.26 0 01-.259-.259.26.26 0 01.259-.26h2.937a.26.26 0 01.26.26.26.26 0 01-.26.26z"
        fill="#fff"
      />
      <path
        d="M80.36 80.134h-1.921a.213.213 0 00-.213.213v.092c0 .118.095.213.213.213h1.92a.213.213 0 00.213-.213v-.092a.213.213 0 00-.213-.213z"
        fill="#407BFF"
      />
      <path
        d="M17.174 75.481l2.573-40.887a.689.689 0 01.673-.635h66.435c.347 0 .616.287.595.635l-2.573 40.887a.689.689 0 01-.673.636H17.766a.594.594 0 01-.595-.636h.003z"
        fill="#fff"
      />
      <path
        opacity=".1"
        d="M54.97 32.699L32.84 74.857H16.515a.59.59 0 01-.595-.635l2.572-40.887a.689.689 0 01.674-.636H54.97zM74.346 32.699L52.22 74.857h-5.163L69.187 32.7h5.159zM86.192 33.334l-2.573 40.888a.686.686 0 01-.673.635H57.797L79.927 32.7h5.67c.35 0 .616.287.595.636z"
        fill="#407BFF"
      />
      <path
        opacity=".4"
        d="M54.19 32.733a.52.52 0 01-.507.48.443.443 0 01-.446-.48.52.52 0 01.506-.48c.263 0 .465.214.447.48z"
        fill="#fff"
      />
      <path
        d="M43.212 22.937c-1.938 2.223-3.058 9.035-1.62 12.392 1.436 3.353-15.219 6.709-1.477 12.154 13.742 5.445 24.727-.867 20.751-6.51-3.976-5.644.429-15.042-4.174-17.415-4.16-2.145-9.593-5.082-13.476-.621h-.004z"
        fill="#263238"
      />
      <path
        d="M39.109 50.377c-.727 2.5-1.5 4.983-2.3 7.462a280.701 280.701 0 01-2.516 7.413l-.337.927-.17.465-.053.142-.085.206c-.053.135-.135.284-.205.423a3.91 3.91 0 01-1.492 1.513 4.1 4.1 0 01-1.86.49c-1.11.018-1.914-.249-2.655-.522a14.92 14.92 0 01-1.995-.987c-2.438-1.464-4.433-3.2-6.336-5.136l1.528-1.804c.513.33 1.06.681 1.594 1.012.539.334 1.088.65 1.627.966 1.088.621 2.183 1.211 3.263 1.673.539.23 1.074.43 1.574.557.485.139.963.185 1.155.135.1-.017.081-.056 0-.025-.085.025-.17.125-.174.114-.003-.01 0 0 0-.021v-.021l.029-.09.134-.458.27-.923 2.168-7.459a391.335 391.335 0 012.275-7.444l4.56 1.392z"
        fill="#B65B52"
      />
      <path
        d="M20.526 60.905l-4.103-1.534 1.634 4.358s2.902.419 4.029-1.112l-.918-1.233a1.418 1.418 0 00-.642-.483v.004zM12.773 60.648l1.566 3.573 3.717-.49-1.633-4.358-3.65 1.275z"
        fill="#B55B52"
      />
      <path
        d="M36.1 43.945c-1.881.48-3.2 8.247-3.2 8.247l5.188 3.537s4.975-7.835 3.526-9.91c-1.51-2.159-2.767-2.574-5.514-1.874z"
        fill="#407BFF"
      />
      <path
        opacity=".5"
        d="M36.1 43.945c-1.881.48-3.2 8.247-3.2 8.247l5.188 3.537s4.975-7.835 3.526-9.91c-1.51-2.159-2.767-2.574-5.514-1.874z"
        fill="#fff"
      />
      <path
        opacity=".2"
        d="M35.93 46.768l4.033.934.386 3.95c-1.052 2.177-2.257 4.074-2.257 4.074l-3.147-2.142c.135-1.815.478-5.59.989-6.816h-.004z"
        fill="#000"
      />
      <path
        d="M36.1 43.944s-2.175.767 2.183 27.64h18.554c-.312-7.57-.319-12.237 3.289-27.772 0 0-3.888-.848-7.881-1.04-3.122-.15-5.68-.252-8.427 0-3.618.33-7.721 1.172-7.721 1.172h.003z"
        fill="#407BFF"
      />
      <path
        opacity=".5"
        d="M36.1 43.944s-2.175.767 2.183 27.64h18.554c-.312-7.57-.319-12.237 3.289-27.772 0 0-3.888-.848-7.881-1.04-3.122-.15-5.68-.252-8.427 0-3.618.33-7.721 1.172-7.721 1.172h.003z"
        fill="#fff"
      />
      <path
        opacity=".2"
        d="M55.764 51.027l2.395 2.042c-.51 2.717-.854 4.98-1.074 6.993-.446-2.017-1.587-7.49-1.322-9.035z"
        fill="#000"
      />
      <path
        d="M51.416 33.264c-.532 2.717-1.063 7.696.836 9.508 0 0-1.761 4.07-6.467 4.07-4.706 0-1.96-4.07-1.96-4.07 3.023-.725 2.945-2.973 2.42-5.083l5.174-4.425h-.003z"
        fill="#B55B52"
      />
      <path
        d="M51.646 41.757c-.447.905-1.882 2.98-5.904 3.715a.421.421 0 01-.319-.064c-.754-.526-1.219-1.638-.889-2.927.092-.355-.252-.668-.588-.526-.4.167-.734.373-.886.473a.419.419 0 00-.145.16c-.291.554-1.482 3.267 2.108 4.94a.449.449 0 00.18.043c2.11.042 5.844-.373 8.193-4.625a.448.448 0 00-.039-.49c-.258-.327-.733-.657-1.087-.877a.438.438 0 00-.624.174v.004zM52.635 52.937l-4.784-.139a.363.363 0 01-.355-.394l.046-.59a.41.41 0 01.415-.373l4.784.139a.363.363 0 01.354.394l-.046.59a.41.41 0 01-.414.373z"
        fill="#FAFAFA"
      />
      <path
        opacity=".2"
        d="M49.307 35.068l-3.062 2.618c.128.5.224 1.005.26 1.499 1.154-.167 2.742-1.439 2.862-2.65.06-.603.036-1.186-.063-1.467h.003z"
        fill="#000"
      />
      <path
        d="M54.987 28.129c-.854 4.464-1.123 6.371-3.688 8.385-3.86 3.033-9.14 1.002-9.632-3.626-.443-4.166 1.031-10.765 5.656-11.987 4.557-1.204 8.519 2.763 7.664 7.228z"
        fill="#B55B52"
      />
      <path
        d="M52.45 24.818c-.553 2.795-.68 6.51 1.889 6.51 2.57 0 4.557-4.361 2.353-7.774-2.204-3.414-3.916-.388-4.238 1.26l-.004.004z"
        fill="#263238"
      />
      <path
        d="M56.87 25.163c0 3.04-3.82 1.538-5.515.224-1.694-1.31-1.786-1.169-4.9-1.172-3.115-.007-3.76-.217-4.685-1.716-.925-1.498-.843-2.486 1.244-2.17 2.083.316.333-1.815 1.889-2.997 1.555-1.183 3.387-.885 5.513 1.814 2.126 2.7 6.457.75 6.457 6.017h-.004z"
        fill="#263238"
      />
      <path
        d="M55.745 32.092c.402-1.374.008-2.7-.88-2.96-.889-.262-1.935.64-2.337 2.015-.401 1.374-.007 2.7.881 2.96.888.262 1.934-.64 2.336-2.015z"
        fill="#fff"
      />
      <path
        d="M48.638 35.53a6.09 6.09 0 01-2.389-.49.133.133 0 01.103-.245 5.805 5.805 0 004.515.024 5.654 5.654 0 003.104-3.107c1.073-3.051 2.147-6.862.893-9.224-.49-.916-1.311-1.53-2.445-1.822a.135.135 0 01-.096-.163.133.133 0 01.163-.096c1.208.312 2.087.97 2.611 1.953 1.304 2.454.217 6.336-.878 9.44a5.932 5.932 0 01-3.25 3.26 6.12 6.12 0 01-2.328.466l-.003.004z"
        fill="#fff"
      />
      <path
        opacity=".6"
        d="M55.618 32.106c-.315 1.08-1.041 1.819-1.619 1.648-.578-.17-.79-1.182-.475-2.262.316-1.08 1.042-1.819 1.62-1.648.577.17.79 1.183.474 2.262z"
        fill="#407BFF"
      />
      <path
        d="M46.632 34.446l-1.389-.268a.45.45 0 00-.527.357l-.015.08a.451.451 0 00.356.529l1.389.268a.45.45 0 00.527-.358l.015-.08a.451.451 0 00-.356-.528z"
        fill="#fff"
      />
      <path
        d="M44.818 28.494s-.823 1.495-1.606 2.17c.425.515 1.272.415 1.272.415l.334-2.582v-.003z"
        fill="#A02724"
      />
      <path
        d="M45.6 32.989s.018.01.029.01c1.237.153 2.193-.646 2.232-.681a.068.068 0 00.008-.096.068.068 0 00-.096-.008c-.01.008-.953.796-2.126.65a.07.07 0 00-.078.06c0 .03.01.054.032.068v-.003zM49.65 26.74a.143.143 0 00.132-.006.138.138 0 00.043-.192c-.617-.98-1.574-1.009-1.613-1.009a.143.143 0 00-.142.135c0 .075.06.139.135.142.036 0 .85.029 1.386.878a.125.125 0 00.06.053zM47.624 28.554c-.064.366-.305.629-.546.59-.24-.04-.383-.37-.319-.739.064-.37.305-.629.546-.59.241.04.383.37.319.74zM43.492 27.85c-.064.367-.304.63-.545.59-.238-.039-.383-.369-.32-.738.064-.366.305-.629.546-.59.241.04.383.37.32.739z"
        fill="#263238"
      />
      <path
        d="M43.273 27.15l-.837-.404s.333.764.837.405zM47.404 27.859l-.836-.405s.333.764.836.405zM42.089 25.377a.13.13 0 00.142-.018c.794-.61 1.57-.352 1.601-.341a.143.143 0 00.178-.085c.028-.071-.015-.153-.085-.178-.04-.014-.947-.323-1.86.384a.14.14 0 00.028.238h-.004z"
        fill="#263238"
      />
      <path
        d="M37.582 76.114s-.05-2.547.701-4.532h18.554s1.67 2.699 2.102 4.532h-21.36.003z"
        fill="#407BFF"
      />
      <path
        d="M57.117 70.492l.15 1.666c.063.128-.09.26-.302.26h-18.77c-.167 0-.305-.083-.316-.19l-.166-1.665c-.01-.114.134-.213.315-.213H56.82c.138 0 .258.057.3.139l-.003.003z"
        fill="#407BFF"
      />
      <path
        opacity=".3"
        d="M57.117 70.492l.15 1.666c.063.128-.09.26-.302.26h-18.77c-.167 0-.305-.083-.316-.19l-.166-1.665c-.01-.114.134-.213.315-.213H56.82c.138 0 .258.057.3.139l-.003.003z"
        fill="#FAFAFA"
      />
      <path
        d="M54.594 72.599h.503c.1 0 .178-.053.17-.114l-.237-2.163c-.007-.064-.096-.114-.195-.114h-.503c-.1 0-.177.054-.17.114l.237 2.163c.007.064.096.114.195.114zM39.608 72.599h.504c.099 0 .177-.053.17-.114l-.238-2.163c-.007-.064-.095-.114-.195-.114h-.503c-.099 0-.177.054-.17.114l.237 2.163c.008.064.096.114.195.114zM47.1 72.599h.503c.099 0 .177-.053.17-.114l-.238-2.163c-.007-.064-.095-.114-.194-.114h-.504c-.099 0-.177.054-.17.114l.238 2.163c.007.064.095.114.195.114z"
        fill="#407BFF"
      />
      <path
        d="M61.717 49.063a349.48 349.48 0 012.35 7.995l1.13 4.003.563 1.989.142.49.07.245.018.057v.014s.004.01.004.014l-.057-.089c-.046-.064-.124-.177-.326-.334a1.736 1.736 0 00-.95-.337 1.543 1.543 0 00-.75.15c-.256.138-.231.17-.21.145.032-.022.096-.09.167-.174.141-.17.3-.409.457-.661.315-.508.62-1.087.914-1.676.599-1.18 1.145-2.43 1.694-3.683.542-1.258 1.07-2.533 1.59-3.811.54-1.272 1.043-2.572 1.564-3.843l2.264.678a90.403 90.403 0 01-2.12 8.2 56.646 56.646 0 01-1.416 4.071c-.277.682-.571 1.364-.936 2.07a10.54 10.54 0 01-.652 1.109 5.868 5.868 0 01-.496.632c-.22.224-.46.494-1.028.785a2.664 2.664 0 01-1.254.263 2.554 2.554 0 01-1.428-.522 2.924 2.924 0 01-.67-.721 3.852 3.852 0 01-.301-.55l-.096-.232-.064-.174-.092-.252-.184-.5c-.241-.668-.485-1.329-.709-1.993-.453-1.328-.907-2.653-1.332-3.985a191.585 191.585 0 01-2.427-8.023l4.574-1.346-.003-.004z"
        fill="#B65B52"
      />
      <path
        d="M60.13 43.813c1.86.568 4.705 7.881 4.705 7.881l-7.211 5.168s-3.242-6.255-2.463-8.663c.815-2.507 2.85-5.033 4.968-4.386z"
        fill="#407BFF"
      />
      <path
        opacity=".5"
        d="M60.13 43.813c1.86.568 4.705 7.881 4.705 7.881l-7.211 5.168s-3.242-6.255-2.463-8.663c.815-2.507 2.85-5.033 4.968-4.386z"
        fill="#fff"
      />
      <path
        d="M70.165 50.518l-.989-4.368 4.11 2.174s.054 2.94-1.605 3.867l-1.513-1.673h-.003zM70.895 42.68l2.622 1.865-.234 3.775-4.107-2.173 1.719-3.467z"
        fill="#B55B52"
      />
      <path
        d="M1.315 24.737h28.703c2.34 0 4.136 1.918 3.994 4.262l-.794 13.024c-.142 2.344-2.172 4.262-4.51 4.262h-3.325l1.358 4.472-6.496-4.472H.001c-2.339 0-4.136-1.918-3.994-4.262L-3.199 29c.142-2.344 2.172-4.262 4.51-4.262h.004z"
        fill="#407BFF"
      />
      <path
        d="M27.389 31.558H3.112a.748.748 0 01-.751-.803.87.87 0 01.85-.803h24.277c.44 0 .78.363.751.803a.87.87 0 01-.85.803zM13.02 36.313H2.822a.748.748 0 01-.752-.802.87.87 0 01.85-.803h10.2c.439 0 .779.362.75.803a.87.87 0 01-.85.802zM21.737 41.07H2.531a.748.748 0 01-.751-.803.87.87 0 01.85-.803h19.203c.44 0 .78.362.75.803a.87.87 0 01-.85.802h.004zM20.486 36.313h-4.011a.748.748 0 01-.751-.802.87.87 0 01.85-.803h4.011c.44 0 .78.362.752.803a.87.87 0 01-.85.802z"
        fill="#fff"
      />
      <path
        d="M41.283 1.332H25.635c-1.821 0-3.398 1.491-3.512 3.317l-.62 10.133c-.11 1.825 1.287 3.317 3.108 3.317h2.587l-1.482 3.477 5.479-3.477h9.064c1.822 0 3.398-1.492 3.512-3.317l.62-10.133c.11-1.826-1.286-3.317-3.108-3.317z"
        fill="#407BFF"
      />
      <path
        d="M41.283 1.33H25.635c-1.821 0-3.398 1.493-3.512 3.318l-.62 10.133c-.11 1.826 1.287 3.317 3.108 3.317h2.587l-1.482 3.477 5.479-3.477h9.064c1.822 0 3.398-1.491 3.512-3.317l.62-10.133c.11-1.825-1.286-3.317-3.108-3.317z"
        fill="#FAFAFA"
        opacity=".5"
      />
      <path
        d="M33.736 11.373c-.096.458-.528.784-.993.784h-.924l.02-.483c.036-.593.164-1.083.383-1.466.22-.384.638-.814 1.255-1.293.617-.48.989-.792 1.113-.941.191-.235.294-.494.311-.778.025-.395-.113-.728-.407-1.009-.298-.28-.709-.42-1.24-.42-.532 0-.95.147-1.311.438-.21.17-.387.39-.532.664-.206.387-.61.629-1.028.575-.648-.081-.995-.792-.652-1.374.202-.345.472-.657.812-.945.712-.6 1.62-.899 2.718-.899 1.158 0 2.059.302 2.707.91.648.607.946 1.31.897 2.117a2.46 2.46 0 01-.454 1.264c-.276.398-.847.938-1.708 1.623-.447.355-.73.64-.843.856-.05.092-.093.217-.124.37v.007zm-2.024 2.55l.007-.11a1.03 1.03 0 011.01-.956h.114c.524 0 .924.426.893.956l-.008.11a1.03 1.03 0 01-1.01.955h-.113a.886.886 0 01-.893-.955z"
        fill="#fff"
      />
    </svg>
  );
});

CustomerCareWidgetIllustration.displayName = 'CustomerCareWidgetIllustration';

export { CustomerCareWidgetIllustration };
